import { defineStore } from 'pinia';

type ModalContent = {
  descriptions?: string;
  items: string[];
};

type State = {
  title: string;
  content: ModalContent | undefined;
  type?: 'error' | 'success' | 'warning' | 'info';
  closeAction?: () => void;
};

export const useUserAlreadyInviteModalStore = defineStore('duplicate-user-modal', {
  state: (): State => ({
    title: '',
    type: undefined,
    content: undefined,
    closeAction: undefined
  }),
  getters: {
    getTitle: state => {
      return state.title;
    },
    getType: state => {
      return state.type;
    },
    getContent: state => {
      return state.content;
    },
    getShowModal: state => {
      return !!state.content && !!state.title;
    },
    getCloseAction: state => {
      return state.closeAction;
    }
  },
  actions: {
    setGlobalInfoModal(title: string, type: string, content: ModalContent, close?: () => void) {
      this.title = title;
      this.type = type;
      this.content = content;
      this.closeAction = close ?? undefined;
    }
  }
});
